














































































import { Component, Vue, Watch } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import ImageUpload from '@/components/ImgUpload/index.vue'
import { addContestantRoundDetail, queryContestantRoundDetailById, updateContestantRoundDetail } from '@/api/player.ts'
import { UserModule } from '@/store/modules/user'
import { baseUrl } from '@/config.json'
import { getToken } from '@/utils/cookies'
import { encrypt, decrypt } from '@/utils/crypto'

@Component({
  name: 'addPromotionalImage',
  components: {
    HeadLable,
    ImageUpload
  }
})
export default class extends Vue {
  private restKey: number = 0
  private textarea: string = ''
  private value: string = ''
  private title = '新增轮次参赛选手';
  private title1 = '';
  private imageUrl: string = ''
  private actionType: string = 'add'
  private vueRest = '1'
  private index = 0
  private inputStyle = { flex: 1 }
  private titleId = ''
  private titleId1 = ''
  private round = ''
  private roundTitle = ''
  private addType = 0
  private headers = {
    token: getToken()
  }
  private ruleForm = {
    id: '',
    contestant: '',
    name: '',
    gender: '',
    departureGroup: '',
    sequence: '',
    tee: '',
  }

  get rules() {
    return {
      contestant: {
        required: true,
        message: '球员编号不能为空'
      },
      name: {
        required: true,
        message: '轮次参赛选手姓名不能为空'
      },
      gender: {
        required: true,
        message: '轮次参赛选手性别不能为空'
      },
      departureGroup: {
        required: true,
        message: '轮次参赛选手出发组不能为空'
      },
      tee: {
        required: true,
        message: '轮次参赛开球tee不能为空'
      },
      sequence: {
        required: true,
        message: '轮次参赛选手出场顺序不能为空'
      },
    }
  }

  created() {
    this.titleId1 = this.$route.query.titleId;
    this.round = this.$route.query.round;
    this.roundTitle = this.$route.query.roundTitle;
    if (this.$route.query.title) {
      this.title1 = this.$route.query.title
    }
    this.actionType = this.$route.query.id ? 'edit' : 'add';
    this.name()
    if (this.$route.query.id) {
      this.title = '修改轮次参赛选手信息';
      this.init();
    }
  }

  private name() {
    try {
      // 解密
      this.titleId = decrypt(this.$route.query.titleId as string)
    } catch (e) {
      console.error("解密失败:", e)
      // this.title = "默认标题"
    }
  }

  changeAddType(number: number) {
    if (number == 0) {
      document.getElementById('add')!.style.backgroundColor = "#ffc200"
      document.getElementById('reduce')!.style.backgroundColor = "#f0f0f0"
      this.addType = 0
    } else {
      document.getElementById('reduce')!.style.backgroundColor = "#ffc200"
      document.getElementById('add')!.style.backgroundColor = "#f0f0f0"
      this.addType = 1
    }
  }

  cancel() {
    this.$router.push({ path: '/competition/scoreRoundDetailManage', query: { titleId: this.titleId1, title: this.title1,roundTitle: this.roundTitle,id: this.round,type: 0 } })
  }

  // 判断是否有权限
  private hasPermission(): boolean {
    const roles = UserModule.username || [];
    if (roles.includes('admin')) return true;
    return false;
  }

  private async init() {
    queryContestantRoundDetailById(this.$route.query.id).then(res => {
      if (res && res.data && res.data.code === 1) {
        this.imageUrl = res.data.data.photo
        this.ruleForm = res.data.data
      } else {
        this.$message.error(res.data.msg)
      }
    })
  }

  private submitForm(formName: any, st: any) {
    ;(this.$refs[formName] as any).validate((valid: any) => {
      console.log(valid, 'valid')
      if (valid) {
        if (!this.ruleForm.contestant) return this.$message.error('球员编号不能为空')
        if (!this.ruleForm.name) return this.$message.error('轮次参赛选手姓名不能为空')
        if (!this.ruleForm.gender) return this.$message.error('轮次参赛选手性别不能为空')
        if (!this.ruleForm.departureGroup) return this.$message.error('轮次参赛选手出发组不能为空')
        if (!this.ruleForm.tee) return this.$message.error('轮次参赛选手开球tee不能为空')
        if (!this.ruleForm.sequence) return this.$message.error('轮次参赛选手出场顺序不能为空')
        // let params: any = { ...this.ruleForm }
        let params: any = {}
        // params.flavors = this.dishFlavors
        params.contestant = this.ruleForm.contestant
        params.name = this.ruleForm.name
        params.gender = this.ruleForm.gender
        params.departureGroup = Number(this.ruleForm.departureGroup)
        params.round = this.round
        params.sequence = this.ruleForm.sequence
        params.tee  = this.ruleForm.tee
        // params.type = 1
        // params.price *= 100
        if (this.actionType == 'add') {
          params.titleId = this.titleId
          delete params.id
          addContestantRoundDetail(params)
            .then(res => {
              if (res.data.code === 1 && res.data.data != '球员编号重复！') {
                this.$message.success('轮次参赛选手新增成功！')
                  this.$router.push({ path: '/competition/scoreRoundDetailManage', query: { titleId: this.titleId1, title: this.title1,roundTitle: this.roundTitle,id: this.round,type: 0 } })
              } else {
                this.$message.error(res.data.data || res.data.msg)
              }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        } else {
          delete params.createTime
          delete params.updateTime
          params.id = this.ruleForm.id
          params.titleId = this.titleId
          updateContestantRoundDetail(params)
            .then(res => {
              if (res && res.data && res.data.code === 1 && res.data.data != '球员编号重复!') {
                this.$router.push({ path: '/competition/scoreRoundDetailManage', query: { titleId: this.titleId1, title: this.title1,roundTitle: this.roundTitle,id: this.round,type: 0 } })
                this.$message.success('轮次参赛选手信息修改成功！')
              } else {
                this.$message.error(res.data.data || res.data.msg)
              }
              // if (res.data.code == 200) {
              //   this.$router.push({'path': '/dish'})
              //   this.$message.success('菜品修改成功！')
              // } else {
              //   this.$message.error(res.data.desc || res.data.message)
              // }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message)
            })
        }
      } else {
        return false
      }
    })
  }

  imageChange(value: any) {
    this.ruleForm.photo = value
  }
}
